import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'diabetes_diagnosis'

const OPTIONS = [
  {
    value: 'no',
    translationKey: 'pages.onboarding.diabetesDiagnosis.options.no',
  },
  {
    value: 'prediabetes',
    translationKey: 'pages.onboarding.diabetesDiagnosis.options.prediabetes',
  },
  {
    value: 'type-2',
    translationKey: 'pages.onboarding.diabetesDiagnosis.options.type2',
  },
  {
    value: 'type-1',
    translationKey: 'pages.onboarding.diabetesDiagnosis.options.type1',
  },
  {
    value: 'not-sure',
    translationKey: 'pages.onboarding.diabetesDiagnosis.options.notSure',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '✅',
    title: 'pages.onboarding.diabetesDiagnosis.options.no',
    value: 'no',
  },
  {
    emoji: '⚠️',
    title: 'pages.onboarding.diabetesDiagnosis.options.prediabetes',
    value: 'prediabetes',
  },
  {
    emoji: '💊',
    title: 'pages.onboarding.diabetesDiagnosis.options.type2',
    value: 'type-2',
  },
  {
    emoji: '🩺',
    title: 'pages.onboarding.diabetesDiagnosis.options.type1',
    value: 'type-1',
  },
  {
    emoji: '❓',
    title: 'pages.onboarding.diabetesDiagnosis.options.notSure',
    value: 'not-sure',
  },
]

export default function DiabetesDiagnosisPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Have you been diagnosed with diabetes or prediabetes?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.diabetesDiagnosis.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
